import { useCallback, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #387 — attach an emergency manual ride's ScoreSheets onto the real FVD ride
// once it has synced in (score-api POST /ride/:rideId/resolve, #388). The
// server HARD-BLOCKS with 409 (code "test_mismatch") if any ScoreSheet's
// testId doesn't match the target ride's testId — all-or-nothing, no partial
// writes. The caller (AttachRideDialog) already blocks the same case
// client-side; this is the last-line server enforcement, kept in case of a
// race or a bypassed client check.
//
// #3354 -- the admin can cross a mismatch with an explicit confirm: pass
// { confirmTestMismatch: true } and the server attaches anyway and records the
// tests crossed on the audit event.
//
// #3535 -- { changeTargetTest: true } attaches AND switches the real ride onto
// the manual ride's test; a sheet already there on another test is set aside.
export function useResolveManualRide() {
  const scoreApi = useScoreApi();
  const [resolving, setResolving] = useState(false);

  const resolve = useCallback(
    async (manualRideId, targetRideId, { confirmTestMismatch = false, changeTargetTest = false } = {}) => {
      setResolving(true);
      try {
        return unwrap(
          await scoreApi.rides.resolveManualRide(manualRideId, {
            targetRideId,
            ...(confirmTestMismatch ? { confirmTestMismatch: true } : {}),
            ...(changeTargetTest ? { changeTargetTest: true } : {}),
          }),
        );
      } finally {
        setResolving(false);
      }
    },
    [scoreApi],
  );

  return { resolve, resolving };
}

export default useResolveManualRide;
